import React from 'react';
import { getIdentifiers } from './identifiers';
import { Facebook } from './Facebook';
import { Twitter } from './Twitter';
import styles from './styles.module.css';
import { Context } from '../LocaleWrapper';

const buttonComponents: { [key: string]: React.FC } = {
  facebook: Facebook,
  twitter: Twitter,
};

export function SocialSharing(): React.ReactElement | null {
  const { i18n } = React.useContext(Context);
  const invitation = i18n('social-media.invitation-to-share');
  const buttonIdentifiers = getIdentifiers(i18n);

  if (!buttonIdentifiers) {
    return null;
  }

  const buttons = buttonIdentifiers.map((identifier) => {
    const Component = buttonComponents[identifier];

    return <Component key={identifier} />;
  });

  return (
    <div>
      <div className={styles.block}>
        <span className={styles.invitation}>{invitation}</span>
        {buttons}
      </div>
    </div>
  );
}
